var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('vue-horizontal',_vm._l((_vm.courses),function(course){return _c('section',{key:course.id,staticClass:"item"},[_c('Card',{attrs:{"course":course,"cardType":_vm.cardType}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }